import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Contact requests")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Type a subject, name ...",
      solo: "",
      "hide-details": "auto",
      "append-icon": "fa-search",
      loading: _vm.datatable_loading,
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", {
    staticClass: "w100p"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.filterTreated,
      "item-value": "value",
      "item-text": "label",
      label: "Filter by status",
      "hide-details": "auto",
      solo: "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.treated,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "treated", $$v);
      },
      expression: "searchCriterias.treated"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.filterRead,
      "item-value": "value",
      "item-text": "label",
      label: "Filter by read",
      "hide-details": "auto",
      solo: "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.read,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "read", $$v);
      },
      expression: "searchCriterias.read"
    }
  }), _c(VSelect, {
    attrs: {
      label: "Salesperson",
      items: _vm.listSalesman,
      "item-value": "id_user",
      "item-text": "fullname",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.salesmanId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "salesmanId", $$v);
      },
      expression: "searchCriterias.salesmanId"
    }
  })], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfContacts
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c("div", {
    staticClass: "ma-2 mb-4"
  }, [_c(VCard, {
    staticClass: "pa-3",
    attrs: {
      color: "grey lighten-4 d-flex align-start",
      rounded: ""
    }
  }, [_c(VTooltip, {
    attrs: {
      bottom: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            icon: "",
            "x-small": "",
            color: "grey darken-2",
            disabled: _vm.isMarkableAsRead || !_vm.selectedRows.length > 0
          },
          on: {
            click: function click($event) {
              return _vm.markMultipleAsRead();
            }
          }
        }, "v-btn", attrs, false), on), [_c(VIcon, [_vm._v("fa fa-envelope")])], 1)];
      }
    }])
  }, [_c("span", [_vm._v("Mark as read")])]), _c(VDivider, {
    staticClass: "mx-4",
    attrs: {
      vertical: ""
    }
  }), _c(VTooltip, {
    attrs: {
      bottom: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            icon: "",
            "x-small": "",
            color: "grey darken-2",
            disabled: _vm.isMarkableAsTreated || !_vm.selectedRows.length > 0
          },
          on: {
            click: function click($event) {
              return _vm.markMultipleAsTreated();
            }
          }
        }, "v-btn", attrs, false), on), [_c(VIcon, [_vm._v("fa fa-check-circle")])], 1)];
      }
    }])
  }, [_c("span", [_vm._v("Mark as treated")])])], 1)], 1), _c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id_contact",
      "items-per-page": _vm.searchCriterias.paging.limits,
      loading: _vm.datatable_loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": "",
      "item-class": _vm.readBackground,
      "show-select": ""
    },
    on: {
      "click:row": _vm.rowClicked
    },
    scopedSlots: _vm._u([{
      key: "item.treated",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "text-smaller pt-1"
        }, [_c(VIcon, {
          attrs: {
            small: "",
            color: item.treated ? "green" : "red"
          }
        }, [_vm._v("fa-circle")]), item.treated ? _c("div", [_c("div", [_vm._v("Treated by")]), _c("div", [_vm._v(_vm._s(item.treatedBy))]), _c("div", [_vm._v("(" + _vm._s(_vm._f("formatDateTime")(item.treatedDate)) + ")")])]) : _vm._e()], 1)];
      }
    }, {
      key: "item.read",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "text-smaller"
        }, [item.read ? [_c("div", [_vm._v("Read by")]), _c("div", [_vm._v(_vm._s(item.readBy))]), _c("div", [_vm._v("(" + _vm._s(_vm._f("formatDateTime")(item.readDate)) + ")")])] : [_c("div", [_vm._v("Not read")])]], 2)];
      }
    }, {
      key: "item.date_contact",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDateTime")(item.date_contact)) + " ")];
      }
    }, {
      key: "item.salesman",
      fn: function fn(_ref6) {
        var _item$salesman;
        var item = _ref6.item;
        return [_c("div", [_vm._v(" " + _vm._s(((_item$salesman = item.salesman) === null || _item$salesman === void 0 || (_item$salesman = _item$salesman.fullname) === null || _item$salesman === void 0 ? void 0 : _item$salesman.length) > 0 ? item.salesman.fullname : _vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.showDetails(item);
            }
          }
        }, [_vm._v("Details")]), !item.treated ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.confirmTreated(item.id_contact);
            }
          }
        }, [_vm._v("Treated")]) : _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.confirmNotTreated(item.id_contact);
            }
          }
        }, [_vm._v("Not treated")])])])];
      }
    }]),
    model: {
      value: _vm.selectedRows,
      callback: function callback($$v) {
        _vm.selectedRows = $$v;
      },
      expression: "selectedRows"
    }
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfContacts
    }
  })], 1)]), _c("contact-popin", {
    ref: "contact"
  }), _c("confirm", {
    ref: "confirm"
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };